<template>
  <section>
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters">
          <el-form-item label="项目">
            <ProjectList @proSelected="proChange"></ProjectList>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="filters.time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="按标题搜索" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSerch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="showAddView">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--列表-->
    <template>
      <el-table :data="data" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="discloseName" label="标题">
        </el-table-column>
        <el-table-column label="已接受交底人数" sortable align="center" width="150">
          <template slot-scope="scope">
            <div class="confirmBtn"
                 @click="showConfirm(scope.row.id)">{{scope.row.confirm}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="unconfirm" label="未接受交底人数" sortable align="center">
          <template slot-scope="scope">
            <div class="confirmBtn"
                 @click="showUnConfirm(scope.row.id)">{{scope.row.unconfirm}}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" sortable align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column label="操作" width="251" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="doDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
      <el-dialog :visible.sync="confirmUsers" :modal="false" ref="confirmDialog" title="已接受交底人">
        <span v-for="(item,index) in confirmUserNs" style="margin-right: 10px;">{{item.employeeName}}</span>
      </el-dialog>
      <el-dialog :visible.sync="unconfirmUsers" :modal="false" ref="confirmDialog" title="未接受交底人">
        <span v-for="(item,index) in confirmUserNs" style="margin-right: 10px;">{{item.employeeName}}</span>
      </el-dialog>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
        <DiscloseForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData"
                      :type="GLOBAL.safeType"></DiscloseForm>
      </div>
    </el-dialog>
    <!-- 详情界面 -->
    <el-dialog title="交底详情" :visible.sync="detailsVisible" :modal="false" class="details" :close-on-click-modal="false" top="1vh" @close="mesClose">
      <div class="mtitle">交底单</div>
      <table cellpadding="0" cellspacing="1">
        <tr>
          <td>交底单名称：{{formData.discloseName}}</td>
          <td>单位工程名称：{{formData.discloseProName}}</td>
        </tr>
        <tr>
          <td>交底人：{{formData.employeeName}}</td>
          <td>施工部位：{{formData.discloseConsPosition}}</td>
        </tr>
        <tr>
          <td>分部工程/分项：{{formData.code.name}}</td>
          <td>交底日期：{{formData.formatDate}}</td>
        </tr>

        <tr>
          <td colspan="2">
            <div class="d_label">通用交底</div>
            <div>
              {{formData.discloseCommon}}
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="d_label">专用交底</div>
            <div>
              {{formData.discloseSpecial}}
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="d_label">接受交底人</div>
            <div>
              {{formData.discloseAcceptUserN}}
            </div>
          </td>
        </tr>
      </table>
      <div style="margin-top: 20px;height: 30px; line-height: 30px;font-size: 18px; width: 600px;">
        <span>签名区：</span>
      </div>
      <div style=" height: 200px; width: 600px; border:1px dotted #c9c9c9; position: relative;">
        <canvas id="sign" width="600" height="200"></canvas>
        <div style="position: absolute; right: -87px; top: 5px;"><el-button type="success" size="small" :disabled="checkVisible" @click="checkSign">确认完成</el-button></div>
        <div style="position: absolute; right: -87px; top: 45px;"><el-button type="warning" size="small" @click="clearSign">更改清空</el-button></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span v-bind:class="{'use_dispaly':useAccpt}"><el-button type="success" @click="accpt" :disabled="btnVisible">接受交底</el-button></span>
        <el-button @click.native="detailsVisible = false">取消</el-button>
        <el-button type="primary" @click="exportDoc">导出</el-button>
        <el-button v-on:click="qrcodeView" type="success">查看二维码</el-button>
      </div>
    </el-dialog>
    <!-- 二维码视图 -->
    <el-dialog :visible.sync="qrcodeVisible" title="查看二维码" :modal="false" :close-on-click-modal="false">
      <div class="q-title" style="text-align: center">{{formData.discloseName}}-交底单</div>
      <div slot="footer">
        <div id="qrcode"></div>
      </div>
      <div slot="footer"> 接受交底人：{{formData.discloseAcceptUserN}}</div>
    </el-dialog>
  </section>
</template>

<script>
  import {
    discloseSearch,
    discloseDel,
    discloseDetail,
    usersBydisid,
    updateByuseranddis,
    disclosedoc,
    roleFuns,
    proSearch
  } from '../../api/api'
  import DiscloseForm from "./DiscloseForm";
  import QRCode from 'qrcodejs2'
  import ProjectList from "../command/ProjectList";

  export default {
    name: "company",
    components: {ProjectList, DiscloseForm},
    data() {
      return {
        data: [],
        page: 1,
        total: 0,
        limit: 15,
        filters: {proId:null,},
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        formVisible: false,
        detailsVisible: false,
        loading: false,
        option: 0,//0 添加 1 修改
        formData: {code: {name: ''}},
        confirmUsers: false,
        confirmUserNs: [],
        unconfirmUsers: false,
        useAccpt: true,
        submitObj: {},
        detailId: 0,
        qrcodeVisible: false,
        proList:[],
        //=============
        btnVisible:true,
        checkVisible:false
      }
    },
    methods: {
      //查询数据
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.safeDisclose, this.GLOBAL.option.select, this);
        this.loading = true;
        let rangTime = this.filters.time + "";
        let beginTime = null, endTime = null;
        if (rangTime) {
          beginTime = rangTime.split(",")[0];
          beginTime = new Date(beginTime);
          endTime = rangTime.split(",")[1];
          endTime = new Date(endTime);
        }

        let params = {
          page: this.page,
          limit: 15,
          beginTime: beginTime,
          endTime: endTime,
          searchTab: this.filters.searchTab,
          type: this.GLOBAL.safeType,
          comId: this.GLOBAL.user.comId,
          proId: this.filters.proId == '' ? null : this.filters.proId
        };//请求参数
        discloseSearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });
      },
      //查询
      doSerch: function () {
        this.searchData();
      },
      //分页查询
      searchPage(val) {
        this.page = val
        this.searchData();
      },
      resetForm: function () {
        this.filters = {}
      },
      //添加视图
      showAddView: function () {
        //标记权限验证 this.GLOBAL.roleTag.safer
        this.GLOBAL.checkRoleTag( this.GLOBAL.roleTag.safer,this);
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeDisclose, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {discloseDate: new Date(), code: {name: ''},proId:null,discloseUser:null}
          this.formVisible = true;
        }

      },
      //编辑视图
      showEditView: function (index, row) {
        //标记权限验证 this.GLOBAL.roleTag.safer
        this.GLOBAL.checkRoleTag( this.GLOBAL.roleTag.safer,this);
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeDisclose, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          discloseDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeDisclose, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
            discloseDel({id: row.id}, this.GLOBAL.header).then(result => {

              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }

      },
      //查看详情
      openDetails: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeDisclose, this.GLOBAL.option.message, this);
        if (res) {
          this.detailId = row.id;
          discloseDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.discloseAcceptUserN = this.formData.discloseAcceptUserN.split(',');
              let acceptUser = [];
              acceptUser = this.formData.discloseAcceptUser.split(',');
              if (acceptUser.indexOf(this.GLOBAL.user.id + "") > -1) {
                this.useAccpt = false;
              }
              this.signAreaInit();
              this.clearSign();
            }
          });
          this.detailsVisible = true
        }

      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.updateTime, "yyyy-MM-dd hh:mm:ss");
      },
      //加载已交底人
      showConfirm: function (obj) {
        this.confirmUsers = true;
        this.confirmUserNs = [];
        usersBydisid({id: obj, status: 1}, this.GLOBAL.header).then(result => {
          if (result.data.length > 0) {
            this.confirmUserNs = result.data;
          } else {
            this.confirmUserNs.push({employeeName: '暂无数据'});
          }

        });
      },
      //加载未交底人
      showUnConfirm: function (obj) {
        this.unconfirmUsers = true;
        this.confirmUserNs = [];
        usersBydisid({id: obj, status: 0}, this.GLOBAL.header).then(result => {
          if (result.data.length > 0) {
            this.confirmUserNs = result.data;
          } else {
            this.confirmUserNs.push({employeeName: '暂无数据'});
          }

        });
      },
      //确认交底
      accpt: function () {
        this.submitObj.userId = this.GLOBAL.user.id
        this.submitObj.reId = this.detailId;
        this.submitObj.parent = 0;
        this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
            updateByuseranddis(this.submitObj, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "成功",
                  type: 'success'
                });
                this.searchData();
              } else {
                this.$message({
                  message: "失败",
                  type: 'error'
                });
              }
              this.detailsVisible = false;
              this.btnVisible = true;
            });
        }).catch(() => {
        });
      },
      //导出doc
      exportDoc: function () {
        disclosedoc({reId: this.detailId,userId:this.GLOBAL.user.id}, this.GLOBAL.header).then(result => {
          this.downloadFile("/doc/disclose_" + this.detailId + ".docx");
        });
      },
      qrcodeView() {
        this.qrcodeVisible = true
        this.qrcode.makeCode( this.GLOBAL.baseDomainUrl+ '/discloseview?id=' + this.detailId+'&userId='+this.GLOBAL.user.id);
      },
      showQEcodeView: function () {
        this.qrcode = new QRCode('qrcode', {
          width: 150, //图像宽度
          height: 150, //图像高度
          colorDark: '#000000', //前景色
          colorLight: '#ffffff', //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
      },
      proChange:function(proId){
        this.filters.proId = proId;
        this.doSerch();
      },
      //初始化签名区
      signAreaInit:function(){
        canvas = document.getElementById('sign');
        if (canvas.getContext) {
          context = canvas.getContext('2d');
        }
        let _this = this;
        let initUrl = apiUrl + 'InitialDevice?id=2&width=600&height=200';
        let getInkUrl = apiUrl + 'GetInks';
        $.ajax({
          url: initUrl,
          type: 'GET',
          cache: false
        }).done(function (response) {
          if (response === true) {
            let isPolling = true;
            getInk(isPolling,getInkUrl);
          } else {
            alert('No device!');
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          alert('Connection fail(' + jqXHR.status + ')!');
        });
      },
      clearSign:function(){
        let clrInkUrl = apiUrl + 'Clear';
        $.ajax({
          url: clrInkUrl,
          type: 'GET',
          cache: false,
          success: function success() {
            let canvas = document.getElementById('sign');
            if(context!=null && context!='undefined' && canvas!=null && canvas!='undefined')
            context.clearRect(0, 0, canvas.width, canvas.height);
          }
        });
      },
      checkSign:function(){
        let oldPic = 'data:image/png;base64,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';
        let pic = document.getElementById("sign").toDataURL("image/png");
        if(pic==oldPic){
          this.$message({
            message: "请完成签名",
            type: 'warning'
          });
        }else{
          pic = pic.replace(/^data:image\/(png|jpg);base64,/, "");
          let _this = this;
          $.ajax({
            type: 'POST',
            url: this.GLOBAL.businessServerPath+'/saveimage',
            data: '{ "imageData" : "' + pic + '" ,"fix":'+this.GLOBAL.user.id+'}',
            headers: {token: this.GLOBAL.user.token, 'Content-Type': 'application/json;charset=utf8'},
            dataType: 'json',
            success: function (result) {
              if(result.success){
                _this.submitObj.replyPhoto = result.data;
                _this.btnVisible = false;
                _this.$message({
                  message: "完成签名",
                  type: 'success'
                });
              }
            }
          });
        }

      },
      mesClose:function(){
        clearTimeout(timeId);
        this.clearSign();
        this.btnVisible = true;
        this.useAccpt = true;
      },
      downloadFile: function (file) {
        if (file != null && file != '') {
          let url = this.GLOBAL.baseDocumentPath + file;    // 获取图片地址
          let a = document.createElement('a');          // 创建一个a节点插入的document
          let event = new MouseEvent('click')       // 模拟鼠标click点击事件
          a.download = 'disclose'                  // 设置a节点的download属性值
          a.href = url;                                 // 将图片的src赋值给a节点的href
          a.dispatchEvent(event)                        // 触发鼠标点击事件
        }
      },
    },
    mounted() {
      this.showQEcodeView();
    },
    destroyed() {
      clearTimeout(timeId);
      this.clearSign();
      this.btnVisible = true;
      this.useAccpt = true;
    }
  }
  //==========================================
  function getInk(isPolling,getInkUrl){
    (function poll() {
       timeId = setTimeout(function () {
        clearTimeout(timeId);
        if (isPolling) {
          $.ajax({
            url: getInkUrl,
            type: 'GET',
            cache: false
          }).done(function (data) {
            let dataInfos = JSON.parse(data);
            dataInfos.forEach(function (value) {
              if (value.EventType === 0) {
                drawImage(value.Image);
              }
            });
          }).always(function () {
            if (isPolling) {
              poll();
            } else {}
          });
        }
      }, 50);
    })();
  }
  let timeId;
  let canvas;
  let context;
  let apiUrl = "http://127.0.0.1:8089/PPSignSDK/"
  function drawImage(base64) {
    let dataUrl = 'data:image/png;base64,';
    dataUrl = dataUrl + base64;
    // 在image中載入圖檔，再畫到canvas呈現
    let img = new Image();
    img.addEventListener('load', function () {
      context.drawImage(this, 0, 0, canvas.width, canvas.height);
    }, false);
    img.src = dataUrl;
  };
  // Generate random number
  function generateString(length) {
    let text = "";
    let possible = "0123456789";

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }return text;
  }
  //==========================================
</script>

<style scoped>
  .confirmBtn {
    width: 50px;
    height: 20px;
    margin: auto;
    background: #55c03c;
    border-radius: 20px;
    cursor: pointer;
    color: #ffffff;
  }

  .details .mtitle {
    position: relative;
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .details .d_label {
    height: 30px;
    line-height: 30px;
  }

  .details table {
    width: 100%;
    background: #d0d0d0
  }

  .details table tr {
    background: #f1f1f1;
    height: 60px;
    text-indent: 2em
  }
</style>



// WEBPACK FOOTER //
// src/components/disclose/SafeDisclose.vue